var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30752 7.11565C3.30752 4.47747 4.67426 3.11194 7.27107 3.11194H15.4533V2.8797C15.4533 0.966094 14.4875 0 12.5923 0H2.86105C0.947608 0 0 0.966094 0 2.8797V12.6521C0 14.575 0.947608 15.5318 2.86105 15.5318H3.30752V7.11565ZM7.40775 20H17.139C19.0433 20 20 19.0432 20 17.1296V7.25499C20 5.34138 19.0433 4.37529 17.139 4.37529H7.40775C5.50342 4.37529 4.5467 5.34138 4.5467 7.25499V17.1296C4.5467 19.0432 5.50342 20 7.40775 20ZM12.2916 16.3679C11.8724 16.3679 11.5444 16.0242 11.5444 15.5597V12.9772H8.98406C8.56492 12.9772 8.18223 12.6057 8.18223 12.1784C8.18223 11.7696 8.56492 11.3888 8.98406 11.3888H11.5444V8.81561C11.5444 8.36043 11.8724 8.01672 12.2916 8.01672C12.7107 8.01672 13.0478 8.36043 13.0478 8.81561V11.3888H15.5262C15.9909 11.3888 16.3645 11.751 16.3645 12.1784C16.3645 12.615 15.9909 12.9772 15.5262 12.9772H13.0478V15.5597C13.0478 16.0242 12.7107 16.3679 12.2916 16.3679Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddVariant);
export default __webpack_public_path__ + "static/media/icon-add-variant.b708ec117120369c7d67832b6bad2287.svg";
export { ForwardRef as ReactComponent };